import PropTypes from 'prop-types';
import { TextareaInput } from 'components/FormControl';

export default function ProductItem({ control, errors, name, value, viewOnly }) {
  return (
    <>
      {' '}
      {viewOnly ? (
        <>
          <h5 className="mb-1">{value.header}</h5>
          <p className="mb-0">{value?.detail}</p>
        </>
      ) : (
        <div>
          <TextareaInput control={control} errors={errors} name={`${name}.value`} row={3} />
        </div>
      )}
    </>
  );
}

ProductItem.propTypes = {
  errors: PropTypes.shape({}).isRequired,
  control: PropTypes.shape({}).isRequired,
  name: PropTypes.string.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  value: PropTypes.object,
  viewOnly: PropTypes.bool,
};

ProductItem.defaultProps = {
  value: {},
  viewOnly: false,
};
